import { get, post, put, destroy } from 'utils/fetchRequest';

export const getPartners = async (search) => {
    try {
        return await get(`partners${search ? `?search=${search}` : ''}`);
    } catch (err) {
        return { error: err };
    }
};

export const getPartner = async (id) => {
    try {
        return await get(`partners/${id}`);
    } catch (err) {
        return { error: err };
    }
};

export const createPartner = async (data) => {
    try {
        return await post('partners', data);
    } catch (err) {
        return { error: err };
    }
};

export const updatePartner = async (id, data) => {
    try {
        return await put(`partners/${id}`, data);
    } catch (err) {
        return { error: err };
    }
};

export const deletePartner = async (id) => {
    try {
        return await destroy(`partners/${id}`);
    } catch (err) {
        return { error: err };
    }
};

export const reorderPartners = async (items) => {
    try {
        return await put('partners/reorder', { items });
    } catch (err) {
        return { error: err };
    }
};
